<template>
<div class="detail-page jobs">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<van-cell-group>
		    <van-cell class="detail-title">
		        <h2>{{job_details.post_title}}</h2>
				<p class="attrs">
					<span class="c999 mt5 left pl20" v-if="job_details.post_area!=''">工作地点：{{job_details.post_area}}</span>
					<span class="c999 mt5 pr20 right" v-if="job_details.post_sub_title!=''">招聘人数：{{job_details.post_sub_title}}</span>
				</p>
		    </van-cell>
		    <van-cell class="detail-content">
				<div class="jobs-c" v-if="job_details.post_excerpt!=''">
					<div class="tit">岗位职责：</div>
					<p><pre v-html="job_details.post_excerpt"></pre></p>
				</div>
				<div class="jobs-c" v-if="job_details.post_content!=''">
					<div class="tit">任职要求：</div>
					<p><pre v-html="job_details.post_content"></pre></p>
				</div>
		    </van-cell>
		</van-cell-group>

		<div class="text-center btn-submit fixed bottom60" style="z-index:999;">
		 	<van-uploader name="uploadFile" preview-size="120px" accept=".doc,.docx,.xls,.xlsx,.pdf" v-model="fileList" multiple :max-count="maxCount" :after-read="afterFiles" :before-delete="deleteFiles">
		 	  <van-button icon="plus" type="info" size="large">上传内部岗位应聘申请表</van-button>
		 	</van-uploader>
		</div>
		<Footer></Footer> <!-- 尾部 -->
		
		<div class="right-tip-jobs">
			<ul>
				<li>
					<a :href="CoreNew.CECPORT_URL+'upload/internal_jobs.docx'">
						<i class="van-icon van-icon-description van-uploader__file-icon"></i>
						<p>下载内部岗位应聘申请表</p>
					</a>
				</li> 
			</ul>
		</div>
		
	</div>
</div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
  created() { 
		var $rus=this.$router.history;
		this.id=$rus["current"].query.id;
		this.getDetail();	
  },
  mounted(){
	  document.title = "招聘详情";	  
	  this.watermark.set(this.ADMIN.USER_NAME+"_"+this.ADMIN.USER_CODE); //水印
	  //滚动
	  window.addEventListener('scroll', function(){
	  		  $(".detail-page .detail-title").addClass("fixedtitle");
	  		  $(".detail-page .detail-content").css("margin-top",$(".detail-page .detail-title").height());
	  }, true);
  },
  data() {
    return {
	  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
	  OA_API_URL:this.CoreNew.OA_API_URL,
	  URLTOKEN:encodeURIComponent(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))),
	  id:0,
	  job_details: [],
	  files:[],//提交的文件
	  fileList: [],
	  attachment:"",//附件保存的路径
	  attachment_name:"",//附件名字
	  maxCount:1,
	};
   },
   filters: {
   },
   methods: {
	    onDown:function(){
			const link = document.createElement('a')
			link.style.display = 'none'
			link.href = this.CoreNew.CECPORT_URL+"upload/internal_jobs.docx"
			link.download = '内部岗位应聘申请表.docx' // 下载的文件名
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
	    onSubmit:function(){
			let post_data = new FormData();
			post_data.append("jobs_id",this.id);
			post_data.append("user_name",this.ADMIN.USER_NAME);
			post_data.append("user_code",this.ADMIN.USER_CODE);
			post_data.append("user_mobile",this.ADMIN.USER_PHONE);
			post_data.append("user_email",this.ADMIN.USER_EMAIL);
			post_data.append("attachment",this.attachment);
			post_data.append("attachment_name",this.attachment_name);
			axios.post(this.CoreNew.CECPORT_URL+"jobs/save/",post_data,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(function (response) {
				console.log(response.data);
				$("#loading").hide();
				if(response.data>0){
					this.$toast("投递成功");
					var time = 3;
					var timer = setInterval(function() {
						time--;
						if(time == 0) {
							window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'jobs';
							clearInterval(timer);//清楚定时
						}
					}, 1000);
				}else{
					this.$toast("投递失败");
				}
			}.bind(this)).catch(function (error) { 
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--保存上传简历--失败"+error);//记录错误
				console.log("请求--保存上传简历--失败"+error);
			});
	    },
		deleteFiles:function(file,name){
			this.files.splice(name.index,1);
			return Promise;
		},
	    afterFiles:function(file){
	    	this.files=this.files.concat(file.file);
			//上传图片
			$("#loading").show();
			let post_data = new FormData();
			post_data.append("uptype","word");
			post_data.append("upfile","Filedata");
			post_data.append("rename","1");
			post_data.append("upload_path","jobs/");
			post_data.append("Filedata",this.files[0]);
			axios.post(this.CoreNew.CECPORT_URL+"upload/upload_files/",post_data,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(function (response) {
				console.log(response);
				if(response.data.filepath_save && response.data.filepath_save!=""){
					this.attachment=response.data.filepath_save;
					this.attachment_name=this.files[0].name;
					this.onSubmit();//保存
				}else{
					$("#loading").hide();
					this.$toast("投递异常，稍后再试"); return false; 
				}	
			}.bind(this)).catch(function (error) { 
				$("#loading").hide();
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--保存上传简历--失败"+error);//记录错误
				console.log("请求--保存上传简历--失败"+error);
			});
	    },
		getDetail: function () {
			axios.get(this.CoreNew.CECPORT_URL+"icapi/getJobsDetail/", {
				params: {jid:this.id}
			}).then(function (response) {
				if(response.data.status==1){
					var $rs=response.data;
					this.job_details=$rs.lists;
				}else{
					this.job_details=[];
					this.$dialog.alert({
					  message: '此招聘已被撤回',
					  showConfirmButton:false,
					  overlayClass:"error-user"
					});
					return false;
				}
			}.bind(this)).catch(function (error) { 
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--招聘详细页--失败"+error);//记录错误
				console.log("请求--招聘详细页--失败"+error); 
			});
	    }
   }
};
</script>
<style>
	.right-tip-jobs {
	    display: inline-block;
	    position: fixed;
		top:50%;
	    right: 0;
	    z-index: 997;
	    width: 72px;
	    background: #1989fa;
	    border-radius: 4px;
	}
	.right-tip-jobs li {
	    float: left;
	    width: 72px;
	    text-align: center;
	    cursor: pointer;
		padding:10px 0px 5px;
	}
	.right-tip-jobs li .van-uploader__file-icon{
		font-size: 40px;color:#fff;
	}
	.detail-page .content .right-tip-jobs p{
	    font-size: 10px;
		padding:0px 5px;
		line-height: 14px !important;
		color:#fff;
	}
	.right-tip-jobs li img {
	    width: 68px;
	    height: 68px; 
	    border-radius:0;
	}
</style>
